import { css } from '@/styled-system/css';

export const container = css({
  width: '100%',
  borderBottomWidth: 'default',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.neutral',
  color: 'text.neutral',
  fontSize: 'body-sm',
  fontWeight: 'bold',
  lineHeight: 'body-sm',
  paddingBlock: 'tighter',
  paddingInline: 0,
});
